import { useState } from "react";
import firebase from "../../config/firebase";
import {
  Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Spinner,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { addCheckoutQuestion } from "store/actions/checkoutQuestionAction";
function AddCheckoutQuestionModal({ addModal, addToggle, onAdd }) {
  const dispatch = useDispatch();
  const { addLoading } = useSelector((state) => state.checkoutQuestion);
  const { user } = useSelector((state) => state.auth);

  const [questionData, setQuestionData] = useState({
    title: "",
    type: "",
  });
  const [isMandatory, setIsMandatory] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setQuestionData((prevQuestionData) => ({
      ...prevQuestionData,
      [name]: value,
    }));
  };

  const handleModalClick = (e) => {
    if (e.target.closest(".modal-content")) {
      return;
    }
    addToggle();
  };

  const handleCancelToggle = () => {
    setQuestionData({
      title: "",
      type: "",
    });
    setIsMandatory(false);
    addToggle();
  };

  const handleCatalogSubmit = (e) => {
    e.preventDefault();
    let obj = {
      ...questionData,
      position: 0,
      isMandatory: isMandatory,
      restaurantID: user?.restaurantID,
      createdAt: firebase.firestore.Timestamp.now(),
    };
    dispatch(
      addCheckoutQuestion(obj, () => {
        setQuestionData({
          title: "",
          type: "",
        });
        setIsMandatory(false);
        onAdd(obj);
      })
    );
  };

  return (
    <div>
      <Modal isOpen={addModal} toggle={addToggle} onClick={handleModalClick}>
        <ModalHeader toggle={handleCancelToggle}>
          Add Question Details
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleCatalogSubmit}>
            <Row>
              <Col>
                <Label>Question</Label>
                <Input
                  type="text"
                  required
                  name="title"
                  value={questionData.title}
                  placeholder="Question"
                  onChange={handleInputChange}
                />
              </Col>
            </Row>
            <Row className="mt-2 mb-0">
              <Col>
                <FormGroup>
                  <Label>Type</Label>
                  <Input
                    type="select"
                    id="exampleCustomSelect"
                    name="type"
                    required
                    value={questionData.type}
                    onChange={handleInputChange}
                  >
                    <option value="" selected disabled>
                      Select Type
                    </option>
                    <option value="marketing">Marketing</option>
                    <option value="order">Order</option>
                  </Input>
                </FormGroup>
              </Col>
            </Row>
            <Row >
              <Col>
                <div className="form-check w-100 p-0 d-flex align-items-center justify-content-start">
                  <Input
                    type="checkbox"
                    className="form-check-input timing-modal-checkbox m-0"
                    id="applyAllCheckbox"
                    value={isMandatory}
                    onChange={(e) => {
                      setIsMandatory(e.target.checked);
                    }}
                  />
                  <label
                    className="form-check-label timing-modal-checkbox-label ml-2"
                    htmlFor="applyAllCheckbox"
                  >
                    isMandatory
                  </label>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div className="d-flex justify-content-end ">
                  <Button color="primary" disabled={addLoading}>
                    {addLoading ? <Spinner size="sm" /> : "Add"}
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default AddCheckoutQuestionModal;
